import { useMutation } from '@tanstack/react-query'
import { postList } from '../../service/list'

function usePostList() {
  return useMutation({
    mutationKey: ['post-list'],
    mutationFn: postList,
  })
}

export default usePostList
